import React from 'react';

const ASpecialDaysCounterTimerEditor = (props) => {
    return (
        <div>
            {props.children}
            <div className="form-group">
                <label className="col-sm-3 control-label">Numer</label>
                <div className="col-sm-9">
                    <input type="number" name="number" className="form-control" defaultValue={props.settings.number} placeholder="" />
                </div>
            </div>
            <div className="form-group">
                <label className="col-sm-3 control-label">Tekst</label>
                <div className="col-sm-9">
                    <input type="text" name="text" className="form-control" defaultValue={props.settings.text} placeholder="" />
                </div>
            </div>
        </div>
    );
}


export default ASpecialDaysCounterTimerEditor;